// AUTO-GENERATED by scripts/import-media-export.ts.
// To rename or relabel: edit scripts/brand-mapping.ts and re-run
// `npm run media:import`. Do not hand-edit this file.

export type BrandSector =
  | 'fmcg'
  | 'tech'
  | 'fintech'
  | 'services'
  | 'health'
  | 'industrial'
  | 'others'

export type BrandLogo = {
  /** Stable ASCII identifier — matches the file name without extension. */
  slug: string
  /** Latin display name. */
  en: string
  /** Original Farsi brand name. */
  fa: string
  /** Path under public/ — feed to assetUrl(). */
  logo: string
  sector: BrandSector
}

export const brandLogos: BrandLogo[] = [
  {
    slug: 'amade-laziz',
    en: 'Amade Laziz',
    fa: 'آماده لذیذ',
    logo: 'clients/fmcg/amade-laziz.svg',
    sector: 'fmcg',
  },
  {
    slug: 'active-cleaners',
    en: 'Active Cleaners',
    fa: 'اکتیو کلینرز',
    logo: 'clients/fmcg/active-cleaners.svg',
    sector: 'fmcg',
  },
  {
    slug: 'aj-style',
    en: 'AJ Style',
    fa: 'ای-جی استایل',
    logo: 'clients/fmcg/aj-style.svg',
    sector: 'fmcg',
  },
  {
    slug: 'easy-pik',
    en: 'Easy Pik',
    fa: 'ایزی پیک',
    logo: 'clients/fmcg/easy-pik.svg',
    sector: 'fmcg',
  },
  {
    slug: 'jeanswest',
    en: 'Jeanswest',
    fa: 'جین وست',
    logo: 'clients/fmcg/jeanswest.svg',
    sector: 'fmcg',
  },
  { slug: 'dorto', en: 'Dorto', fa: 'دورتو', logo: 'clients/fmcg/dorto.svg', sector: 'fmcg' },
  { slug: 'ramak', en: 'Ramak', fa: 'رامک', logo: 'clients/fmcg/ramak.svg', sector: 'fmcg' },
  { slug: 'rani', en: 'Rani', fa: 'رانی', logo: 'clients/fmcg/rani.svg', sector: 'fmcg' },
  {
    slug: 'roozaneh',
    en: 'Roozaneh',
    fa: 'روزانه',
    logo: 'clients/fmcg/roozaneh.svg',
    sector: 'fmcg',
  },
  { slug: 'zarkam', en: 'Zarkam', fa: 'زرکام', logo: 'clients/fmcg/zarkam.svg', sector: 'fmcg' },
  { slug: 'zamzam', en: 'Zamzam', fa: 'زمزم', logo: 'clients/fmcg/zamzam.svg', sector: 'fmcg' },
  {
    slug: 'silaneh-sabz',
    en: 'Silaneh Sabz',
    fa: 'سیلانه سبز',
    logo: 'clients/fmcg/silaneh-sabz.svg',
    sector: 'fmcg',
  },
  { slug: 'tabiat', en: 'Tabiat', fa: 'طبیعت', logo: 'clients/fmcg/tabiat.svg', sector: 'fmcg' },
  { slug: 'mazmaz', en: 'Mazmaz', fa: 'مزمز', logo: 'clients/fmcg/mazmaz.svg', sector: 'fmcg' },
  {
    slug: 'misswake',
    en: 'Misswake',
    fa: 'میس وویک',
    logo: 'clients/fmcg/misswake.svg',
    sector: 'fmcg',
  },
  { slug: 'mihan', en: 'Mihan', fa: 'میهن', logo: 'clients/fmcg/mihan.svg', sector: 'fmcg' },
  { slug: 'nestle', en: 'Nestle', fa: 'نستله', logo: 'clients/fmcg/nestle.svg', sector: 'fmcg' },
  {
    slug: 'hyperstar',
    en: 'Hyperstar',
    fa: 'هایپراستار',
    logo: 'clients/fmcg/hyperstar.svg',
    sector: 'fmcg',
  },
  { slug: 'henkel', en: 'Henkel', fa: 'هنکل', logo: 'clients/fmcg/henkel.svg', sector: 'fmcg' },
  { slug: 'pakshoo', en: 'Pakshoo', fa: 'پاکشو', logo: 'clients/fmcg/pakshoo.svg', sector: 'fmcg' },
  {
    slug: 'padideh-shimi-gharn',
    en: 'Padideh Shimi Gharn',
    fa: 'پدیده شیمی قرن',
    logo: 'clients/fmcg/padideh-shimi-gharn.svg',
    sector: 'fmcg',
  },
  { slug: 'parjak', en: 'Parjak', fa: 'پرژک', logo: 'clients/fmcg/parjak.svg', sector: 'fmcg' },
  {
    slug: 'panbe-riz',
    en: 'Panbe Riz',
    fa: 'پنبه ریز',
    logo: 'clients/fmcg/panbe-riz.svg',
    sector: 'fmcg',
  },
  { slug: 'pouber', en: 'Pouber', fa: 'پوبر', logo: 'clients/fmcg/pouber.svg', sector: 'fmcg' },
  {
    slug: 'pinoo-baby',
    en: 'Pinoo Baby',
    fa: 'پینو بیبی',
    logo: 'clients/fmcg/pinoo-baby.svg',
    sector: 'fmcg',
  },
  {
    slug: 'charm-evers',
    en: 'Charm Evers',
    fa: 'چرم اورز',
    logo: 'clients/fmcg/charm-evers.svg',
    sector: 'fmcg',
  },
  {
    slug: 'kalaye-khooneh',
    en: 'Kalaye Khooneh',
    fa: 'کالای خونه',
    logo: 'clients/fmcg/kalaye-khooneh.svg',
    sector: 'fmcg',
  },
  { slug: 'kaleh', en: 'Kaleh', fa: 'کاله', logo: 'clients/fmcg/kaleh.svg', sector: 'fmcg' },
  { slug: 'caman', en: 'Caman', fa: 'کامان', logo: 'clients/fmcg/caman.svg', sector: 'fmcg' },
  { slug: 'capo', en: 'Capo', fa: 'کاپو', logo: 'clients/fmcg/capo.svg', sector: 'fmcg' },
  { slug: 'kixmax', en: 'Kixmax', fa: 'کیکس مکس', logo: 'clients/fmcg/kixmax.svg', sector: 'fmcg' },
  { slug: 'golrang', en: 'Golrang', fa: 'گلرنگ', logo: 'clients/fmcg/golrang.svg', sector: 'fmcg' },
  { slug: 'golha', en: 'Golha', fa: 'گلها', logo: 'clients/fmcg/golha.svg', sector: 'fmcg' },
  {
    slug: 'unilever',
    en: 'Unilever',
    fa: 'یونیلیور',
    logo: 'clients/fmcg/unilever.svg',
    sector: 'fmcg',
  },
  {
    slug: 'ibshop',
    en: 'IB Shop',
    fa: 'آی بی شاپ',
    logo: 'clients/tech/ibshop.svg',
    sector: 'tech',
  },
  { slug: 'otaghak', en: 'Otaghak', fa: 'اتاقک', logo: 'clients/tech/otaghak.svg', sector: 'tech' },
  {
    slug: 'snappexpress',
    en: 'Snapp Express',
    fa: 'اسنپ اکسپرس',
    logo: 'clients/tech/snappexpress.svg',
    sector: 'tech',
  },
  {
    slug: 'snappbox',
    en: 'Snapp Box',
    fa: 'اسنپ باکس',
    logo: 'clients/tech/snappbox.svg',
    sector: 'tech',
  },
  {
    slug: 'snapptrip',
    en: 'Snapp Trip',
    fa: 'اسنپ تریپ',
    logo: 'clients/tech/snapptrip.svg',
    sector: 'tech',
  },
  {
    slug: 'snappshop',
    en: 'Snapp Shop',
    fa: 'اسنپ شاپ',
    logo: 'clients/tech/snappshop.svg',
    sector: 'tech',
  },
  {
    slug: 'snappfood',
    en: 'Snapp Food',
    fa: 'اسنپ فود',
    logo: 'clients/tech/snappfood.svg',
    sector: 'tech',
  },
  {
    slug: 'snappmarket',
    en: 'Snapp Market',
    fa: 'اسنپ مارکت',
    logo: 'clients/tech/snappmarket.svg',
    sector: 'tech',
  },
  { slug: 'snapp', en: 'Snapp', fa: 'اسنپ', logo: 'clients/tech/snapp.svg', sector: 'tech' },
  { slug: 'okala', en: 'Okala', fa: 'اکالا', logo: 'clients/tech/okala.svg', sector: 'tech' },
  {
    slug: 'iranserver',
    en: 'Iran Server',
    fa: 'ایران سرور',
    logo: 'clients/tech/iranserver.svg',
    sector: 'tech',
  },
  {
    slug: 'boomerang',
    en: 'Boomerang',
    fa: 'بومرنگ',
    logo: 'clients/tech/boomerang.svg',
    sector: 'tech',
  },
  {
    slug: 'technogold',
    en: 'Techno Gold',
    fa: 'تکنو گلد',
    logo: 'clients/tech/technogold.svg',
    sector: 'tech',
  },
  {
    slug: 'technolife',
    en: 'Technolife',
    fa: 'تکنولایف',
    logo: 'clients/tech/technolife.svg',
    sector: 'tech',
  },
  { slug: 'jajiga', en: 'Jajiga', fa: 'جاجیگا', logo: 'clients/tech/jajiga.svg', sector: 'tech' },
  {
    slug: 'khanoumi',
    en: 'Khanoumi',
    fa: 'خانومی',
    logo: 'clients/tech/khanoumi.svg',
    sector: 'tech',
  },
  { slug: 'digify', en: 'Digify', fa: 'دیجی فای', logo: 'clients/tech/digify.svg', sector: 'tech' },
  { slug: 'divar', en: 'Divar', fa: 'دیوار', logo: 'clients/tech/divar.svg', sector: 'tech' },
  {
    slug: 'reality-show-rock',
    en: 'Reality Show Rock',
    fa: 'رئالیتی شو رک',
    logo: 'clients/tech/reality-show-rock.svg',
    sector: 'tech',
  },
  {
    slug: 'safartap',
    en: 'Safartap',
    fa: 'سفرتاپ',
    logo: 'clients/tech/safartap.svg',
    sector: 'tech',
  },
  { slug: 'sanjagh', en: 'Sanjagh', fa: 'سنجاق', logo: 'clients/tech/sanjagh.svg', sector: 'tech' },
  {
    slug: 'alibaba',
    en: 'Alibaba',
    fa: 'علی بابا',
    logo: 'clients/tech/alibaba.svg',
    sector: 'tech',
  },
  {
    slug: 'fastclick',
    en: 'Fastclick',
    fa: 'فست کلیک',
    logo: 'clients/tech/fastclick.svg',
    sector: 'tech',
  },
  {
    slug: 'flytoday',
    en: 'Flytoday',
    fa: 'فلای تودی',
    logo: 'clients/tech/flytoday.svg',
    sector: 'tech',
  },
  { slug: 'filimo', en: 'Filimo', fa: 'فیلیمو', logo: 'clients/tech/filimo.svg', sector: 'tech' },
  {
    slug: 'sefar-sepid',
    en: 'Sefar Sepid',
    fa: 'نوآوران سفر دنیای سپید',
    logo: 'clients/tech/sefar-sepid.svg',
    sector: 'tech',
  },
  {
    slug: 'haft-hashtad',
    en: '7080',
    fa: 'هفت هشتاد',
    logo: 'clients/tech/haft-hashtad.svg',
    sector: 'tech',
  },
  { slug: 'prupay', en: 'Prupay', fa: 'پراپی', logo: 'clients/tech/prupay.svg', sector: 'tech' },
  {
    slug: 'pingotrip',
    en: 'Pingotrip',
    fa: 'پینگوتریپ',
    logo: 'clients/tech/pingotrip.svg',
    sector: 'tech',
  },
  { slug: 'ap', en: 'Ap', fa: 'آپ', logo: 'clients/fintech/ap.svg', sector: 'fintech' },
  {
    slug: 'azki-sarmayeh',
    en: 'Azki Sarmayeh',
    fa: 'از کی سرمایه',
    logo: 'clients/fintech/azki-sarmayeh.svg',
    sector: 'fintech',
  },
  {
    slug: 'bank-sepah',
    en: 'Bank Sepah',
    fa: 'بانک سپه',
    logo: 'clients/fintech/bank-sepah.svg',
    sector: 'fintech',
  },
  {
    slug: 'bank-saderat',
    en: 'Bank Saderat Iran',
    fa: 'بانک صادرات ایران',
    logo: 'clients/fintech/bank-saderat.svg',
    sector: 'fintech',
  },
  {
    slug: 'blu-bank',
    en: 'Blu Bank',
    fa: 'بلو بانک',
    logo: 'clients/fintech/blu-bank.svg',
    sector: 'fintech',
  },
  {
    slug: 'bitpin',
    en: 'BitPin',
    fa: 'بیت پین',
    logo: 'clients/fintech/bitpin.svg',
    sector: 'fintech',
  },
  { slug: 'tara', en: 'Tara', fa: 'تارا', logo: 'clients/fintech/tara.svg', sector: 'fintech' },
  { slug: 'tap', en: 'Tap', fa: 'تاپ', logo: 'clients/fintech/tap.svg', sector: 'fintech' },
  {
    slug: 'tabdeel',
    en: 'Tabdeel',
    fa: 'تبدیل',
    logo: 'clients/fintech/tabdeel.svg',
    sector: 'fintech',
  },
  {
    slug: 'toranj',
    en: 'Toranj',
    fa: 'ترنج',
    logo: 'clients/fintech/toranj.svg',
    sector: 'fintech',
  },
  {
    slug: 'tamadon',
    en: 'Tamadon',
    fa: 'تمدن',
    logo: 'clients/fintech/tamadon.svg',
    sector: 'fintech',
  },
  {
    slug: 'digipay',
    en: 'DigiPay',
    fa: 'دیجی پی',
    logo: 'clients/fintech/digipay.svg',
    sector: 'fintech',
  },
  {
    slug: 'ramzinex',
    en: 'Ramzinex',
    fa: 'رمزینکس',
    logo: 'clients/fintech/ramzinex.svg',
    sector: 'fintech',
  },
  {
    slug: 'zarpay',
    en: 'Zarpay',
    fa: 'زرپی',
    logo: 'clients/fintech/zarpay.svg',
    sector: 'fintech',
  },
  {
    slug: 'swap-wallet',
    en: 'Swap Wallet',
    fa: 'سواپ ولت',
    logo: 'clients/fintech/swap-wallet.svg',
    sector: 'fintech',
  },
  { slug: 'saraf', en: 'Saraf', fa: 'صراف', logo: 'clients/fintech/saraf.svg', sector: 'fintech' },
  {
    slug: 'ompy-finx',
    en: 'Ompy Finx',
    fa: 'صرافی ارز دیجیتال اوام‌پی فینکس',
    logo: 'clients/fintech/ompy-finx.svg',
    sector: 'fintech',
  },
  {
    slug: 'talasi',
    en: 'Talasi',
    fa: 'طلاسی',
    logo: 'clients/fintech/talasi.svg',
    sector: 'fintech',
  },
  { slug: 'lotus', en: 'Lotus', fa: 'لوتوس', logo: 'clients/fintech/lotus.svg', sector: 'fintech' },
  {
    slug: 'meligold',
    en: 'Meligold',
    fa: 'ملی گلد',
    logo: 'clients/fintech/meligold.svg',
    sector: 'fintech',
  },
  {
    slug: 'nobitex',
    en: 'Nobitex',
    fa: 'نوبیتکس',
    logo: 'clients/fintech/nobitex.svg',
    sector: 'fintech',
  },
  {
    slug: 'wallgold',
    en: 'Wallgold',
    fa: 'وال گلد',
    logo: 'clients/fintech/wallgold.svg',
    sector: 'fintech',
  },
  {
    slug: 'wallex',
    en: 'Wallex',
    fa: 'والکس',
    logo: 'clients/fintech/wallex.svg',
    sector: 'fintech',
  },
  {
    slug: 'poolno',
    en: 'Poolno',
    fa: 'پول نو',
    logo: 'clients/fintech/poolno.svg',
    sector: 'fintech',
  },
  {
    slug: 'agah-brokerage',
    en: 'Agah Brokerage',
    fa: 'کارگزاری آگاه',
    logo: 'clients/fintech/agah-brokerage.svg',
    sector: 'fintech',
  },
  {
    slug: 'farabi-brokerage',
    en: 'Farabi Brokerage',
    fa: 'کارگزاری فارابی',
    logo: 'clients/fintech/farabi-brokerage.svg',
    sector: 'fintech',
  },
  {
    slug: 'mofid-brokerage',
    en: 'Mofid Brokerage',
    fa: 'کارگزاری مفید',
    logo: 'clients/fintech/mofid-brokerage.svg',
    sector: 'fintech',
  },
  {
    slug: 'cs50-tehran',
    en: 'CS50x Tehran',
    fa: 'CS50xTehran',
    logo: 'clients/services/cs50-tehran.svg',
    sector: 'services',
  },
  {
    slug: 'alpha-school',
    en: 'Alpha School',
    fa: 'آلفا اسکول',
    logo: 'clients/services/alpha-school.svg',
    sector: 'services',
  },
  {
    slug: 'hiva-agency',
    en: 'Hiva Agency',
    fa: 'آژانس هیوا',
    logo: 'clients/services/hiva-agency.svg',
    sector: 'services',
  },
  {
    slug: 'bastani-academy',
    en: 'Bastani Academy',
    fa: 'آکادمی باستانی',
    logo: 'clients/services/bastani-academy.svg',
    sector: 'services',
  },
  {
    slug: 'edvan',
    en: 'Edvan',
    fa: 'ادوان',
    logo: 'clients/services/edvan.svg',
    sector: 'services',
  },
  {
    slug: 'mr-tax',
    en: 'Mr. Tax',
    fa: 'اقای مالیات',
    logo: 'clients/services/mr-tax.svg',
    sector: 'services',
  },
  {
    slug: 'tipax',
    en: 'Tipax',
    fa: 'تیپاکس',
    logo: 'clients/services/tipax.svg',
    sector: 'services',
  },
  {
    slug: 'rabik',
    en: 'Rabik',
    fa: 'ربیک',
    logo: 'clients/services/rabik.svg',
    sector: 'services',
  },
  {
    slug: 'classino',
    en: 'Classino',
    fa: 'کلاسینو',
    logo: 'clients/services/classino.svg',
    sector: 'services',
  },
  {
    slug: 'quera',
    en: 'Quera',
    fa: 'کوئرا',
    logo: 'clients/services/quera.svg',
    sector: 'services',
  },
  {
    slug: 'orchid-pharmed',
    en: 'Orchid Pharmed',
    fa: 'ارکید فارمد',
    logo: 'clients/health/orchid-pharmed.svg',
    sector: 'health',
  },
  {
    slug: 'snappdoctor',
    en: 'Snapp Doctor',
    fa: 'اسنپ دکتر',
    logo: 'clients/health/snappdoctor.svg',
    sector: 'health',
  },
  {
    slug: 'ai-medic',
    en: 'AI Medic',
    fa: 'ای آی مدیک',
    logo: 'clients/health/ai-medic.svg',
    sector: 'health',
  },
  {
    slug: 'saya-teb-mana',
    en: 'Saya Teb Mana',
    fa: 'سایا طب مانا',
    logo: 'clients/health/saya-teb-mana.svg',
    sector: 'health',
  },
  {
    slug: 'cinnagen',
    en: 'CinnaGen',
    fa: 'سیناژن',
    logo: 'clients/health/cinnagen.svg',
    sector: 'health',
  },
  {
    slug: 'herlife',
    en: 'Herlife',
    fa: 'هرلایف',
    logo: 'clients/health/herlife.svg',
    sector: 'health',
  },
  {
    slug: 'hamkadeh',
    en: 'Hamkadeh',
    fa: 'همکده(رسمی)',
    logo: 'clients/health/hamkadeh.svg',
    sector: 'health',
  },
  {
    slug: 'pars-azma-teb',
    en: 'Pars Azma Teb',
    fa: 'پارس آزمای طب',
    logo: 'clients/health/pars-azma-teb.svg',
    sector: 'health',
  },
  {
    slug: 'arian-tire',
    en: 'Arian Tire',
    fa: 'آرین تایر',
    logo: 'clients/industrial/arian-tire.svg',
    sector: 'industrial',
  },
  {
    slug: 'otto-khosravani',
    en: 'Otto Khosravani',
    fa: 'اتو خسروانی',
    logo: 'clients/industrial/otto-khosravani.svg',
    sector: 'industrial',
  },
  {
    slug: 'tosan-motor',
    en: 'Tosan Motor',
    fa: 'توسن موتور',
    logo: 'clients/industrial/tosan-motor.svg',
    sector: 'industrial',
  },
  {
    slug: 'zarrin-sanat',
    en: 'Zarrin Sanat',
    fa: 'زرین صنعت',
    logo: 'clients/industrial/zarrin-sanat.svg',
    sector: 'industrial',
  },
  {
    slug: 'persian-gulf-petrochemicals',
    en: 'Persian Gulf Petrochemicals',
    fa: 'شرکت صنایع پتروشیمی خلیج فارس',
    logo: 'clients/industrial/persian-gulf-petrochemicals.svg',
    sector: 'industrial',
  },
  {
    slug: 'omran-kish',
    en: 'Omran Kish',
    fa: 'عمران کیش',
    logo: 'clients/industrial/omran-kish.svg',
    sector: 'industrial',
  },
  {
    slug: 'iran-novin',
    en: 'Iran Novin',
    fa: 'ایران نوین',
    logo: 'clients/others/iran-novin.svg',
    sector: 'others',
  },
  {
    slug: 'taradodla',
    en: 'Taradodla',
    fa: 'ترددیلا',
    logo: 'clients/others/taradodla.svg',
    sector: 'others',
  },
  {
    slug: 'hamsaz',
    en: 'Hamsaz',
    fa: 'همساز',
    logo: 'clients/others/hamsaz.svg',
    sector: 'others',
  },
  { slug: 'vata', en: 'Vata', fa: 'واتا', logo: 'clients/others/vata.svg', sector: 'others' },
  { slug: 'wiser', en: 'Wiser', fa: 'وایزر', logo: 'clients/others/wiser.svg', sector: 'others' },
  {
    slug: 'ministry-roads',
    en: 'Ministry of Roads',
    fa: 'وزارت راه',
    logo: 'clients/others/ministry-roads.svg',
    sector: 'others',
  },
  {
    slug: 'ministry-welfare',
    en: 'Ministry of Welfare',
    fa: 'وزارت رفاه',
    logo: 'clients/others/ministry-welfare.svg',
    sector: 'others',
  },
  { slug: 'padro', en: 'Padro', fa: 'پادرو', logo: 'clients/others/padro.svg', sector: 'others' },
  { slug: 'kish', en: 'Kish', fa: 'کیش', logo: 'clients/others/kish.svg', sector: 'others' },
]
